import { Interval } from 'content-creation-common/models';
import { clamp } from '../util/numbers';

/**
 * Class to represent a number that has a min and max associated to it.
 * When setting the value, it will be clamped by the interval.
 */
export default class ClampedNumber {
  _interval;
  _value;

  /**
   * @param {Number} value
   * @param {Interval} interval
   */
  constructor(value, interval) {
    this._interval = interval;
    // use setter to set value.
    this.value = value;
  }

  get value() {
    return this._value;
  }

  set value(value) {
    if (!Interval.isInterval(this._interval)) {
      this._value = value;
      return;
    }
    this._value = clamp(value, this._interval.start, this._interval.end);
  }

  get interval() {
    return this._interval;
  }

  set interval(interval) {
    this._interval = interval;
  }
}
